const settings = window.Environment === 'local' ? {
  /**Test */
  apiBaseUrl: process.env.REACT_APP_BASE_API_URL || 'https://apiservice-test.arcese.com/portal_api/api',
  /**Dev */
  //apiBaseUrl: process.env.REACT_APP_BASE_API_URL || 'https://arcuslapimtest.azure-api.net/vlm-portal-dev/api',
  apiExecutionUrl: process.env.REACT_APP_EXECUTION_API_URL || 'https://apiservice-test.arcese.com/vlm-execution/api',
  documentaleUrl: process.env.REACT_DOCUMENTALE_API_URL || 'https://apiservice-test.arcese.com/Documentale',
  telematicsUrl: process.env.REACT_TELEMATICS_API_URL || 'https://apiservice-test.arcese.com/telematics',
  //dev
  // vlmMasterDataUrl: process.env.REACT_MASTERDATA_API_URL || "https://apiservice-dev.arcese.com/vlm-masterdata/api/Fleet",
  //test
  vlmMasterDataUrl: process.env.REACT_MASTERDATA_API_URL || "https://apiservice-test.arcese.com/vlm-masterdata/api/Fleet",

  idpBaseUrl: process.env.REACT_APP_BASE_IDP_URL || "https://arcidentityidpwebtest.azurewebsites.net",
  idpAuthorizeEndpoint: process.env.REACT_APP_IDP_AUTHORIZE_ENDPOINT || "/connect/authorize",
  idpLogoutEndpoint: process.env.REACT_APP_IDP_LOGOUT_ENDPOINT,
  clientId: process.env.REACT_APP_CLIENT_ID,
  privacyUrlIT: process.env.REACT_APP_PRIVACY_URL_ITA,
  privacyUrlEN: process.env.REACT_APP_PRIVACY_URL_ENG,
  HMap_AppKey: process.env.REACT_APP_HMAP_APP_KEY || 'M-aI6S0AkcMgvvZu6d56ar9CeISkv4ZuXhs-MkcWLys',
  appInsightsConnectionString: process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING,

} : window.Settings;

export default settings;